import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "../common/DatePicker";
import Button from "../common/Button";
import { formatDate, toRegionalDateFromISO, toISODateFromRegional, todayIso } from "../../utils/date";

export default function ArchiveEnrollmentModal({
  open,
  enrollmentId,
  studentName,
  enrolledDate,
  defaultEndIso,
  archiving = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  const [endDateUI, setEndDateUI] = useState("");

  useEffect(() => {
    if (!open) return;
    const iso = defaultEndIso || todayIso();
    setEndDateUI(toRegionalDateFromISO(iso));
  }, [open, defaultEndIso]);

  if (!open) return null;

  const handleConfirm = () => {
    const iso = toISODateFromRegional(endDateUI);
    if (!iso) return;
    onConfirm?.(iso);
  };

  const displayName = studentName || t("enrollments.form.student");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{t("enrollments.archiveModal.title")}</h3>
        <p className="text-sm text-gray-600 mb-4">
          {t("enrollments.archiveModal.description", { name: displayName, id: enrollmentId })}
          {enrolledDate ? t("enrollments.archiveModal.enrolledOn", { date: formatDate(enrolledDate) }) : ""}
        </p>

        <label className="block text-sm font-medium text-gray-700 mb-1">{t("enrollments.archiveModal.endDate")}</label>
        <DatePicker
          value={endDateUI}
          onChange={setEndDateUI}
          className="w-full mb-6"
        />

        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onCancel} disabled={archiving}>
            {t("common.cancel")}
          </Button>
          <Button type="button" onClick={handleConfirm} disabled={archiving || !endDateUI}>
            {archiving ? t("enrollments.archiveModal.archiving") : t("common.archive")}
          </Button>
        </div>
      </div>
    </div>
  );
}
